import { render, staticRenderFns } from "./InstructionsContent.vue?vue&type=template&id=4cf779dd&scoped=true&"
import script from "./InstructionsContent.vue?vue&type=script&lang=js&"
export * from "./InstructionsContent.vue?vue&type=script&lang=js&"
import style0 from "./InstructionsContent.vue?vue&type=style&index=0&id=4cf779dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf779dd",
  null
  
)

export default component.exports